









import {Component, Vue} from 'vue-property-decorator';
import SideBarNav from "@/view/sidebar/SideBarNav.vue";
import {mapGetters} from "vuex";
import ProfileHeader from "@/view/profile/components/ProfileHeader.vue";

@Component({
    components: {ProfileHeader, SideBarNav},
    computed: {
        ...mapGetters(['getProfileLoaded']),
    }
})
export default class Profile extends Vue {
}
